import { Icon, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledTooltipIcon = styled(Icon)<{ $isRead: boolean }>`
  ${({ $isRead }) =>
    $isRead &&
    css`
      > path:first-child {
        fill: var(--surface-default);
        stroke: var(--icon-soft);
      }
      > path:last-child {
        fill: var(--icon-soft);
      }
    `}
`;

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const RecapWrapper = styled.div`
  ${typographyV2.bodySm};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RecapValue = styled.span<{ $isNegative: boolean }>`
  color: ${props =>
    props.$isNegative ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
  padding-right: 0.3em;
`;

export const RecapLabel = styled.span`
  color: var(--text-soft);
`;

export const ValueWrapper = styled.div`
  ${typographyV2.bodySm};
  font-family: var(--font-roboto-mono);
`;

export const DescriptionLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleSm};
`;
